import React from 'react';
import { StarIcon } from 'lucide-react';
import { Container } from './Container';
import { salesProof } from '../data/salesProof';
type Stat = {
  value: string;
  label: string;
  star?: boolean;
};
export function StatsStrip() {
  const {
    customersCount,
    rating
  } = salesProof;
  const stats: Stat[] = [customersCount > 0 ? {
    value: `+${customersCount.toLocaleString('es-AR')}`,
    label: 'familias organizadas'
  } : {
    value: '1',
    label: 'pago único'
  }, {
    value: '30',
    label: 'días resueltos'
  }, {
    value: '5',
    label: 'bonos incluidos'
  }, rating > 0 ? {
    value: `${rating.toLocaleString('es-AR')}/5`,
    label: 'calificación',
    star: true
  } : {
    value: '7',
    label: 'días de garantía'
  }];
  return <section aria-label="El sistema en números" className="border-y border-teal-soft bg-white" data-id="element-410" data-mp="qea20jqrybej">
      <Container data-id="element-411" data-mp="1e3umx86hniqg">
        <dl className="grid grid-cols-2 divide-teal-soft py-2 md:grid-cols-4 md:divide-x" data-id="element-412" data-mp="1e3chpm1ulu6e">
          {stats.map(s => <div key={s.label} className="flex flex-col items-center justify-center px-3 py-5 text-center" data-id="element-413" data-mp="2pg08mbsryd98">
              <dt className="sr-only" data-id="element-414" data-mp="2kh5s5gia50sa">{s.label}</dt>
              <dd className="flex items-center gap-1.5 font-heading text-[2.1rem] font-black leading-none text-teal-dark sm:text-[2.5rem]" data-id="element-415" data-mp="2kigr930s5kd2">
                {s.value}
                {s.star && <StarIcon aria-hidden="true" className="h-6 w-6 fill-sun text-sun" data-id="element-416" data-mp="2tgj0g5uo3jbf" />}
              </dd>
              <dd className="mt-1.5 text-sm font-medium text-navy-soft" data-id="element-417" data-mp="3856ta4d4pexo">{s.label}</dd>
            </div>)}
        </dl>
      </Container>
    </section>;
}